import { db } from "../../../mp-database"
export const UPDATE_REGISTER_STUDENT = "UPDATE_REGISTER_STUDENT"

export const fetchSchoolById = id => {
  return dispatch => {
    db.collection("schools")
      .where("id", "==", id)
      .get()
      .then(snapshot => {
        let school = null
        snapshot.forEach(res => {
          let data = res.data()
          if (!data.deleted) {
            school = data
          }
        })
        let payload = {
          school: school,
          isFetched: true
        }
        if (!school) {
          payload.isInvalidId = true
        }
        dispatch(setRegisterStudentData(payload))
      })
      .catch(err => {
        dispatch(
          setRegisterStudentData({
            isFetched: true,
            isInvalidId: true,
            error: err
          })
        )
      })
  }
}

const setRegisterStudentData = payload => {
  return {
    type: UPDATE_REGISTER_STUDENT,
    payload
  }
}
